import { defineStore } from 'pinia';

// See store/payments.js for the rationale — counter lives outside the store
// so $reset() cannot rewind it and let a stale in-flight response commit.
let notesRequestCounter = 0;

export const useOrderNotesStore = defineStore('orderNotes', () => {
    const notes = ref([]);
    const notesLength = computed(() => notes.value.length);

    const orderStore = useOrderStore();

    async function retrieveNotes(order_id = orderStore.getOrderId) {
        const requestId = ++notesRequestCounter;
        const response = await window.axios.get(`orders/${order_id}/notes?sort=-created_at`);
        if (requestId !== notesRequestCounter) {
            return;
        }
        notes.value = response.data.data;
    }

    async function createNote(data, order_id = orderStore.getOrderId) {
        const createdNote = await window.axios.post(`orders/${order_id}}/notes?type=AGENT_NOTE`, data);
        notes.value.unshift(createdNote.data.note);
    }

    async function updateNote(data, note_id, order_id = orderStore.getOrderId) {
        const response = await window.axios.patch(`orders/${order_id}/notes/${note_id}`, data);
        const note = response.data.note;
        let index = notes.value.findIndex((n) => n.id === note.id);
        notes.value[index] = note;
    }

    // Setup-syntax stores don't get a free $reset(); Order.vue and
    // CreateLeadForm.vue both call this on order swap / create-lead mount.
    // Note: notesRequestCounter intentionally lives outside this function so
    // it survives $reset and stale in-flight fetches still get discarded.
    function $reset() {
        notes.value = [];
    }

    return {
        notes,
        notesLength,
        retrieveNotes,
        createNote,
        updateNote,
        $reset,
    };
});
